const texts = {
  subtraction: '-',
  addition: '+',
};

export {
  texts,
};
